import { render, staticRenderFns } from "./BatchAdd.vue?vue&type=template&id=8e4d5fb6&scoped=true"
import script from "./BatchAdd.vue?vue&type=script&lang=js"
export * from "./BatchAdd.vue?vue&type=script&lang=js"
import style0 from "./BatchAdd.vue?vue&type=style&index=0&id=8e4d5fb6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4d5fb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e4d5fb6')) {
      api.createRecord('8e4d5fb6', component.options)
    } else {
      api.reload('8e4d5fb6', component.options)
    }
    module.hot.accept("./BatchAdd.vue?vue&type=template&id=8e4d5fb6&scoped=true", function () {
      api.rerender('8e4d5fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/fallsFlowManageConfig/fallsFlowManage/components/BatchAdd.vue"
export default component.exports